var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { Alert, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTimeZoneService } from "./timeZoneService";
/** Display the signed instant, never the editable row's replacement wall time. */
export var RetainedSignedCloseNotice = function (_a) {
    var close = _a.close, zone = _a.zone, electionName = _a.electionName, _b = _a.now, now = _b === void 0 ? Date.now() : _b;
    var t = useTranslation().t;
    var service = useTimeZoneService();
    var deadline = service.formatDateTimeZone(close.scheduled_at, zone, service.text);
    var processed = !!close.fired_at;
    var reached = Date.parse(close.scheduled_at) <= now;
    return (_jsxs(Alert, { severity: processed ? "info" : "warning", "data-testid": "retained-close-".concat(close.scheduled_event_id, "-").concat(close.election_id), children: [_jsx(Typography, { component: "h3", variant: "body2", sx: { fontWeight: 600 }, children: close.fired_at
                    ? t("lifecycle.signedClose.processed", {
                        time: service.formatDateTimeZone(close.fired_at, zone, service.text),
                    })
                    : t("lifecycle.signedClose.title") }), _jsx(Typography, { variant: "body2", children: t("lifecycle.signedClose.deadline", {
                    election: electionName,
                    time: deadline,
                    code: close.authorized_by.code,
                }) }), _jsx(Typography, { variant: "body2", children: t(processed ? "lifecycle.signedClose.result" : "lifecycle.signedClose.explanation") }), !processed && reached ? (_jsx(Typography, { variant: "body2", children: t("lifecycle.signedClose.reached") })) : null, !processed ? (_jsx(Typography, { variant: "body2", children: t("lifecycle.signedClose.channels", {
                    channels: close.channels
                        .map(function (channel) { return t("common.channel.".concat(channel.toLowerCase())); })
                        .join(", "),
                }) })) : null, close.authorized_by.signers.length ? (_jsxs(Typography, { variant: "body2", children: [t("lifecycle.publish.authorizedBy"), ": ", close.authorized_by.signers.join(", ")] })) : null] }));
};
export var RetainedSignedCloses = function (_a) {
    var closes = _a.closes, zoneOf = _a.zoneOf, nameOf = _a.nameOf, _b = _a.unavailable, unavailable = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var _c = useState(Date.now), now = _c[0], setNow = _c[1];
    useEffect(function () {
        if (!closes.some(function (close) { return !close.fired_at; }))
            return;
        var timer = setInterval(function () { return setNow(Date.now()); }, 15000);
        return function () { return clearInterval(timer); };
    }, [closes]);
    if (!closes.length && !unavailable)
        return null;
    return (_jsxs(Stack, { spacing: 1, "data-testid": "retained-signed-closes", children: [unavailable ? (_jsx(Alert, { severity: "warning", children: t("lifecycle.signedClose.unavailable") })) : null, __spreadArray([], closes, true).sort(function (a, b) { return Date.parse(a.scheduled_at) - Date.parse(b.scheduled_at); })
                .map(function (close) { return (_jsx(RetainedSignedCloseNotice, { close: close, zone: zoneOf(close.election_id), electionName: nameOf(close.election_id), now: now }, "".concat(close.scheduled_event_id, ":").concat(close.election_id, ":").concat(close.fingerprint))); })] }));
};
